import { EcgServiceValues } from '@/types/ble'

const _ecgData = [
  [
    -0.08256695014938964,
    0.0822822010948166,
    0.08155117237995707,
    0.09142518686915946,
    0.1059917810105166,
    0.10904232666244468,
    0.1295238412988368,
    0.12334857646437716,
    0.13122960097028702,
    0.12579316072975127,
    0.140124903476401,
    0.17612413500552332,
    0.16794010695617967,
    0.21388814193097078,
    0.2317459083775546,
    0.24455452455044932,
    0.30050113436032955,
    0.28346904238544945,
    0.3296821311306479,
    0.33490897747885445,
    0.33389264830800025
  ],
  [
    0.33331344026974524,
    0.30189576963438247,
    0.2662053240068255,
    0.21139977820846795,
    0.15138351868149535,
    0.10782658626198935,
    0.030348448640257708,
    -0.0024264725582238134,
    -0.0506364331310839,
    -0.09706667812085917,
    -0.11522232185942355,
    -0.1685035019862291,
    -0.16464995023894713,
    -0.17221166360038778,
    -0.1670056543218491,
    -0.14863187707472475,
    -0.15693914421162916,
    -0.1374111463314562,
    -0.13032209695568098,
    -0.12857654159276274,
    -0.11663947515175561
  ],
  [
    -0.1195520059131449,
    -0.0945764306272864,
    -0.10297545056343009,
    -0.09542695094543513,
    -0.07126555675015873,
    -0.08396250287206938,
    -0.06939140730179384,
    -0.0882142782583304,
    -0.08880221744198012,
    -0.0685198229166927,
    -0.08592377701021316,
    -0.07714510368844549,
    -0.08158004859772659,
    -0.08498686123665469,
    -0.08137455022199651,
    -0.08423147332219934,
    -0.0686680380369844,
    -0.0804035696084316,
    -0.08515849305516894,
    -0.05369653312592729,
    -0.07060409596638405,
    -0.04289390879474878
  ],
  [
    -0.03773747336740964,
    -0.0469462203869254,
    -0.021762221294135763,
    -0.06161669345958815,
    -0.06883924248526223,
    -0.08196164221671294,
    -0.07274592154672334,
    -0.0750792483896875,
    -0.08939201911861967,
    -0.07256452033245894,
    -0.05049056532400495,
    0.0983237621288793,
    0.2629636875137209,
    0.2816337513645612,
    -0.271702127850055,
    -0.9005066573880951,
    -0.8295932726027406
  ],
  [
    -0.6128173479598235,
    -0.4100955742674238,
    -0.055965555973849335,
    0.08804733909418117,
    0.09904669259717999,
    0.11730238204071286,
    0.1132628886373204,
    0.12070403479566252,
    0.12907606506985186,
    0.13783769392366835,
    0.14932061913957723,
    0.15041573059921787,
    0.17327180582222687,
    0.18557794979417722,
    0.21110770504648632,
    0.24412183094515066,
    0.26491981286046973,
    0.3074888662072608
  ]
]

const ecgData = _ecgData.flatMap(v => v)

export default (function* ecgMockGenerator() {
  let index = 0

  while (true) {
    if (Math.random() < 0.2) {
      yield {
        deviceType: 6,
        invalid: false,
        bytes: new ArrayBuffer(0),
        datetime: new Date().toISOString(),
        measurementTime: new Date(),
        heartRate: Math.floor(90 + Math.random() * 10),
        equipped: new Date().getMinutes() % 2 == 0
      } as EcgServiceValues
    } else if (0.2 <= Math.random() && Math.random() < 0.4) {
      yield {
        deviceType: 6,
        invalid: false,
        bytes: new ArrayBuffer(0),
        datetime: new Date().toISOString(),
        battery: 65535 - new Date().getSeconds()
      } as EcgServiceValues
    } else {
      // const ecgValue = ecgData[index] + Math.random() * 0.2
      const ecgValue = ecgData
        .slice(index, index + 30)
        .map(v => v + Math.random() * 0.2)

      yield {
        deviceType: 6,
        invalid: false,
        bytes: new ArrayBuffer(0),
        datetime: new Date().toISOString(),
        ecg: ecgValue,
        trigger1: 255,
        trigger2: 255,
        measurementTime: new Date(),
        pr: Math.floor(90 + Math.random() * 10)
      } as EcgServiceValues
      index += ecgValue.length
      if (index >= ecgData.length - 1) {
        index = 0
      }
    }
  }
})()
